import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'last'
})
export class LastPipe implements PipeTransform {
	transform(_value: any, _args?: unknown): any {
		return null;
	}
}
